module.exports = __webpack_public_path__ + "static/media/expand.7270c36e.svg";